export const REGISTER_USER = "register_user"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"

export const VENDOR_REGISTER = "vendor_register"
export const VENDOR_REGISTER_SUCCESSFUL = "vendor_register_successfull"
export const VENDOR_REGISTER_FAILED = "vendor_register_failed"
